<template>
    <div class="app-container">
      <el-row class="headTop">
        <el-col :span="22" v-show="showShop">
          分店：<el-select class="w150" v-model="shopNum" clearable  placeholder="请选择分店"
          @change="changeShopData(shopNum)">
           <el-option
            v-for="item in this.shopList"
            :key="item.shopNum"
            :label="item.name"
            :value="item.shopNum"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="2" :offset="showShop?0:22">
          <el-button style="width:100%"   type="success" icon="el-icon-circle-plus-outline" @click="showDialog()">新增</el-button>
        </el-col>
      </el-row>
    <el-dialog title="增加教室"  :visible.sync="dialogVisible" width="1000px">
      <el-form :model="formparams" :rules="rules" ref="formparams" label-width="120px">
        <el-form-item label="教室名称" prop="name">
          <el-input class="w220" v-model="formparams.name" placeholder="请输入教室名称" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="分店" prop="shopNum">
          <el-select v-model="formparams.shopNum" placeholder="请选择">
              <el-option
              v-for="item in this.shopList"
              :key="item.shopNum"
              :label="item.name"
              :value="item.shopNum"
              ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
        <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改教室"  :visible.sync="dialogVisible2" width="1000px">
      <el-form :model="formparams2" :rules="rules2" ref="formparams2" label-width="120px">
        <el-form-item label="状态" prop="status">
          <el-select v-model="formparams2.status" placeholder="请选择">
              <el-option
              v-for="item in this.statusList"
              :key="item.value"
              :label="item.lable"
              :value="item.value"
              ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:100px"  @click="resetForm2('formparams')">取 消</el-button>
        <el-button style="width:100px"  type="primary" @click="submitForm2('formparams2')">确 定</el-button>
      </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="73vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <!-- <el-table-column width="200px" prop="tid" label="票ID"></el-table-column> -->
        <el-table-column prop="name" label="教室名称"></el-table-column>
        <el-table-column label="分店">
          <template slot-scope="scope">
            <div> {{scope.row.shopNum|caseType}} </div>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0">可使用</div>
            <div v-if="scope.row.status == 1">维修</div>
            <div v-if="scope.row.status == 2">暂停使用</div>
          </template>
        </el-table-column>
        <el-table-column width="200" label="操作">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">编辑</el-button>
            <!-- <el-button style="width:100px"  type="danger" @click="removeList(scope.row.id)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pageination" style="display:none">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
let that;
import {getShops, insertClassRoom, getClassRoom, updateClassRoom } from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogVisible2: false,
      showShop: false,
      date:[],//开始时间结束时间
      rules:{
        name:[
          { required: true, message: '请输入教室名称', trigger: 'blur' }
        ],
        shopNum:[{ required: true, message: '请选择分店', trigger: 'blur' }],
      },
      rules2:{
        status:[{ required: true, message: '请选择分店', trigger: 'blur' }],
      },
      timeList:[],
      addType:1,
      shopNum:'',
      formparams:{
        name:'',
        shopNum:''
      },
      formparams2:{
        id:'',
        status:''
      },
      statusList:[
        {lable:'可使用',value:0},
        {lable:'维修',value:1},
        {lable:'暂停使用',value:2},
      ],
      formData:{},
      fileList:[],
      //票列表
      tableData:[],
      //票类型
      options:[],
      titleList:[],
      //分店列表
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      total: 0,
      currentPage: 1,
      params: {
        page: 1,
        size: 20
      }
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  components: {
    mainHead
  },
  beforeCreate(){
    that = this;
  },
  created(){
    this.getShopsList()
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    showDialog(){
      this.dialogVisible =true
      this.addType = 1
      this.formparams.name=''
      this.formparams.shopNum=''
    },
    changeShopData(){
      this.getTableList()
    },
    getTableList(){
      getClassRoom({shopNum:this.shopNum,type:0}).then((res)=>{
        if(res.msg == "success"){
            this.tableData = res.data
        }
      })
    },
    //查询分店类型
    getShopsList(){
      getShops({isWeb:1}).then((res)=>{
        this.shopList = res.data
        // this.shopNum = res.data[0].shopNum
        if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
          this.shopNum = this.shopList[0].shopNum
        }
        sessionStorage.setItem('shopList',JSON.stringify(res.data))
        
      })
    },
    //编辑
    edit(row){
      console.log(row)
      this.addType = 2
      this.dialogVisible2 = true
      this.formparams2.id = row.id
      this.formparams2.status = row.status
    },
    //添加票
    // insertOnlineTicketInfo
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if (valid) {
          insertClassRoom(this.formparams).then((res)=>{
            console.log(res)
            if(res.msg=="success"){
              this.$message({
                type:'success',
                message:'添加成功'
              })
              this.dialogVisible = false
              this.getTableList()
            } else{
              this.$message.error(res.data)
            }
          })
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    submitForm2(formparams2){
      this.$refs[formparams2].validate(valid => {
        if (valid) {
          updateClassRoom(this.formparams2).then((res)=>{
            if(res.msg=="success"){
              this.$message({
                type:'success',
                message:'修改成功'
              })
            } else{
              this.$message.error(res.data)
            }
            this.dialogVisible2 = false
            this.getTableList()
          })          
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
    resetForm2(formparams2) {
      this.dialogVisible2 = false;
      // this.$refs[formparams2].clearValidate();
    },
      //分页
    handleSizeChange(val) {
      this.params.size = val;
      this.params.page = 1;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.params.page = val;
    },
  }
};
</script>
<style lang="scss">

</style>


// WEBPACK FOOTER //
// classList.vue?20ac42a9